/**
 * Helper to kill click event propagation and actions.
 *
 * @param {MouseEvent} e
 */
export function stopClickEvent(e) {
  if (!e) {
    return;
  }

  e.stopPropagation();
  e.preventDefault();
}
